(($) => {
    function SessionStorageObject(objectName) {
        this.objectName = objectName;
        this.clear = function () {
            sessionStorage.setItem(this.objectName, JSON.stringify({}));
        }
        this.setValue = function (key, value) {
            var sessionState = JSON.parse(sessionStorage.getItem(this.objectName));
            sessionState[key] = value;
            sessionStorage.setItem(this.objectName, JSON.stringify(sessionState));
        }
        this.getValue = function (key) {
            var sessionState = JSON.parse(sessionStorage.getItem(this.objectName));
            if (sessionState) {
                return sessionState[key];
            }
            return undefined;
        }

        this.clear();
    }

    /* Dimension view builders */
    function baseDimBuilder(dimIndex, viewProductContext, sortBy, groupBy, onClickHandler, onChangeHandler) {
        this.$controlElem = null;
        this.data = null;
        this.itemClass = null;
        this.dimNameContainerClass = "DimensionTxt";
        this.dimInfo = $.extend({}, viewProductContext); // copy context
        this.options = viewProductContext.options;
        this.dimensionIndex = dimIndex;
        this.sortBy = sortBy;
        this.canChangeMainImage = false;
        this.groupBy = groupBy ? new Function('elem', groupBy) : function (dimElem) {
            return dimElem.val.replace(/[^0-9]/g, '');
        };
        this.onClickHandler = onClickHandler;
        this.onChangeHandler = onChangeHandler;
        // Workaround for the backward compatibility
        if (!viewProductContext.dimViewsInfo && viewProductContext.dimTypeMap) {
            // Old logic
            var oldStructureDimTypeMap = viewProductContext.dimTypeMap[this.dimensionIndex];
            if (oldStructureDimTypeMap != null) {
                this.dimInfo.dimTypeInfo = {
                    DimTypeId: oldStructureDimTypeMap.dimTypeId,
                    DimTypeName: oldStructureDimTypeMap.dimTypeName,
                    DimViewType: this.getControlViewType(),
                    SortBy: sortBy,
                    GroupBy: groupBy,
                    PositionInDimArray: dimIndex
                };
            }
        }
        else {
            this.dimInfo.dimTypeInfo = _.find(viewProductContext.dimViewsInfo, function (dimViewInfo) {
                return dimViewInfo.PositionInDimArray === dimIndex;
            });
        }

        this.dimControlId = 'dimControl_' + this.dimInfo.dimTypeInfo.DimTypeId + '_' + new Date().getTime();

        this.sessionStorageObject = new SessionStorageObject(this.getControlViewType());

        this.isNotyShown = false;

        this.init();
    }

    baseDimBuilder.prototype = (function () {
        // the prototype itself
        return {
            constructor: baseDimBuilder,
            getSelectedValue: function () {
                if (this.itemClass) {
                    var selectedElem = $('.' + this.itemClass + '.selected', this.$controlElem);
                    return selectedElem.length === 1 ? selectedElem.attr('data-dimId') : 0;
                }
                throw "getSelectedValue method is not implemented " + this.getControlViewType();
            },
            setSelectedValue: function (selValue, fireOnChangeEvent, isPreselect) {
                if (this.itemClass) {
                    if (!selValue) return;
                    var itemToSelect = $('.' + this.itemClass + '[data-dimId="' + selValue + '"]:not(.disabled' + (isPreselect ? ',.selected' : '') + ')', this.$controlElem);
                    if (itemToSelect.length === 1) {
                        // Clear previous selection
                        var prevSelected = $('.' + this.itemClass + '.selected', this.$controlElem);
                        prevSelected.removeClass('selected');
                        // Select current item if it is not the same as previous (for deselect emulating)
                        if (!prevSelected.is(itemToSelect)) {
                            itemToSelect.addClass('selected');
                        }

                        if (fireOnChangeEvent) {
                            this.handleEvent(this.onChangeHandler, this.getSelectedValue(), this);
                        }
                    }
                } else {
                    throw "setSelectedValue method is not implemented " + this.getControlViewType();
                }
            },
            getControlViewType: function () {
                return "baseDimBuilder";
            },
            getDimensionsCount: function (activeOnly) {
                if (this.itemClass) {
                    var selector = '.' + this.itemClass + (activeOnly ? ':not(.disabled)' : '');
                    return $(selector, this.$controlElem).length;
                }
                throw "getDimensionsCount method is not implemented " + this.getControlViewType();
            },
            filter: function (availableDimIdsArray) {
                var self = this;
                if (this.itemClass) {
                    $('.' + this.itemClass + '[data-dimId]', this.$controlElem).each(function () {
                        var $item = $(this);
                        var val = parseInt($item.attr('data-dimId'));
                        if (!val) return;
                        if (_.contains(availableDimIdsArray, val)) {
                            $item.toggleClass('disabled', false);
                            var baseTitle = self.sessionStorageObject.getValue(val + '_baseTitle');
                            if (baseTitle) {
                                $item[0].title = baseTitle;
                            }
                        } else {
                            $item.toggleClass('disabled', true);
                        }
                    });
                }
            },
            setShowOnly: function (showOnlyDict) {
                var self = this;
                if (this.itemClass) {
                    $('.' + this.itemClass + '[data-dimId]', this.$controlElem).each(function () {
                        var $item = $(this);
                        var val = parseInt($item.attr('data-dimId'));
                        if (!val) return;
                        if (val in showOnlyDict) {
                            var showOnlyReason = showOnlyDict[val].showOnlyReason;
                            if (showOnlyReason) {
                                var originalItemTitle = self.sessionStorageObject.getValue(val + '_baseTitle');
                                if (!originalItemTitle) {
                                    originalItemTitle = $item[0].title;
                                    self.sessionStorageObject.setValue(val + '_baseTitle', originalItemTitle);
                                }
                                $item[0].title = originalItemTitle + ' (' + showOnlyReason + ')';
                            }
                        }
                    });
                }
            },
            resetShowOnly: function () {
                var self = this;
                if (this.itemClass) {
                    $('.' + this.itemClass + '[data-dimId]', this.$controlElem).each(function () {
                        var $item = $(this);
                        var val = parseInt($item.attr('data-dimId'));
                        if (!val) return;

                        var originalDimName = self.sessionStorageObject.getValue(val + '_baseTitle');
                        if (originalDimName) {
                            $item[0].title = originalDimName;
                        }
                    });
                }
            },
            handleEvent: function (customHandler, args, ctx) {
                if (customHandler && $.isFunction(customHandler)) {
                    var eventArgs = [];
                    for (var i = 0; i < args.length; i++) {
                        eventArgs.push(args[i]);
                    }
                    if (!ctx) ctx = this;
                    customHandler.apply(ctx, [this, eventArgs]);
                }
            },
            _prepareData: function () {
                var dimInfo = this.dimInfo;
                if (dimInfo && !$.isEmptyObject(dimInfo)) {
                    // Prepare data for dimension control
                    var controlContext = this;
                    var data = {};
                    for (var prop in dimInfo.dimProds) {
                        if (dimInfo.dimProds.hasOwnProperty(prop)) {
                            var val = dimInfo.dimProds[prop];
                            var dimId = val.dims[controlContext.dimensionIndex];
                            var isSingleDimensionProd = val.dims.length === 1;
                            if (!data[dimId]) {
                                data[dimId] = { id: dimId, val: dimInfo.dimMap[dimId] };
                                if (isSingleDimensionProd) {
                                    data[dimId].price = val.price;
                                    data[dimId].qty = val.qty;
                                    data[dimId].isShowOnly = val.isShowOnly;
                                    data[dimId].showOnlyReason = val.showOnlyReason;
                                }
                            }
                        }
                    }

                    // Filter dimensions by url params (if exist). Incident#00060771
                    var urlDimensionsParam = $.trim($.getQueryStringParam(window.location.search, dimInfo.dimTypeInfo.DimTypeName));
                    if (urlDimensionsParam) {
                        var urlDims = urlDimensionsParam.split(',');
                        data = _.filter(data, function (dim) {
                            return _.contains(urlDims, dim.val);
                        });
                    }

                    if (!_.isEmpty(data)) {
                        // Sort if needed
                        controlContext.data = controlContext.sortBy ? _.sortBy(data, controlContext.sortBy == 'val' ? 'val' : new Function('elem', controlContext.sortBy)) : data;
                    }
                }
            },
            init: function () {
                throw "init method is not implemented in " + this.getControlViewType();
            },
            showDimIsNotSelectedTooltip: function () {
                var tooltipElem = $('.' + this.dimNameContainerClass, this.$controlElem);
                if (!tooltipElem.data('qtip')) {
                    // Initialize qtip
                    var tooltipOptions = {
                        content: {
                            text: this.options.selectDimMsg + ' <b>' + this.dimInfo.dimTypeInfo.DimTypeName + '</b>'
                        },
                        show: {
                            event: 'click',
                            effect: function () {
                                $(this).fadeIn(400);
                            }
                        },
                        hide: {
                            target: $('.' + this.itemClass, this.$controlElem),
                            event: 'click',
                            effect: function () {
                                $(this).fadeOut(400);
                            },
                            inactive: 3000
                        },
                        position: {
                            my: 'left bottom',
                            at: 'right center'
                        },
                        style: {
                            classes: 'DimensionIsNotSelectedTooltip'
                        }
                    };
                    tooltipElem.qtip(tooltipOptions);
                }

                // Show tooltip
                tooltipElem.qtip("show");
            },
            showDimIsNotSelectedNoty: function () {
                if (!this.isNotyShown) {
                    var self = this;
                    var notyContract = {
                        text: this.options.selectDimMsg + ' <b>' + this.dimInfo.dimTypeInfo.DimTypeName + '</b>',
                        callback: {
                            onClose: function () {
                                self.isNotyShown = false;
                            }
                        }
                    };
                    window.PubSub.publish('notification.warning', notyContract);
                    this.isNotyShown = true;
                }
            },
            hasSelectedRelatedDimensionImage: function () { return false; },
            changeMainImageToRelatedDimensionImage: function () { }
        };
    })();

    $.baseDimBuilder = baseDimBuilder;
})(jQuery);